// Модалки от фансибокса
window.fbx = require('@fancyapps/ui/dist/fancybox.esm');

// Анимация прокрутки
window.AOS = require('aos/dist/aos');

// Красивый селект
require('jquery-nice-select/js/jquery.nice-select');

// Отправка формы
window.VEGASFORMSENDER_INIT = false;
require('vgformsender/dist/js/vgformsender');

// VgDropdown
require('../../../vendor/dropdown/jquery.vegasDropdown');

// rangeSlider
require('ion-rangeslider/js/ion.rangeSlider');

// Toastr
window.Toastr = require('toastr');
